const AWS = require('aws-sdk');
const AWS_BUCKET =
  process.env.VUE_APP_NOTE == 'PRODUCT'
    ? process.env.VUE_APP_AWS_BUCKET_PRODUCT
    : process.env.VUE_APP_NOTE == 'STAGING'
    ? process.env.VUE_APP_AWS_BUCKET_STAGING
    : process.env.VUE_APP_AWS_BUCKET_DEV;

const s3 = new AWS.S3();

const s3PutFile = function(param) {
  return s3
    .putObject({
      Bucket: AWS_BUCKET,
      Key: param.key,
      Body: param.file,
      ContentType: param.contentType,
    })
    .promise();
};
const uploadFile = async function(file, type) {
  const key = `${type}/${new Date().getTime()}_${file.name}`;

  let contentType = file.type;

  let param = {
    file,
    key,
    contentType,
  };
  let response = await s3PutFile(param);
  if (response) return response.$response.request.params.Key;
  return null;
};

export default uploadFile;
